import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/answers');

const AnswersFxs = {
    autofillAnswersFx: domain.effect(api.answers.autofillAnswers),
    deleteAnswersFx: domain.effect(api.answers.deleteAnswers),
    getAnswersFx: domain.effect(api.answers.getAnswers),
    getCommonAnswersFx: domain.effect(api.answers.getCommonAnswers),
    putAnswersFx: domain.effect(api.answers.putAnswers),
};

export default AnswersFxs;
